import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  tab: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    maxWidth: 'initial',
    padding: theme.spacing(2, 3),
    textTransform: 'initial',
    '&.MuiTab-textColorInherit': {
      opacity: 1,
    },
  },
  title: {
    color: theme.palette.neutral.dark,

    '&.MuiTypography-gutterBottom': {
      marginBottom: 6,
    },
  },
  subtitle: {
    color: theme.palette.neutral.main,
  },
  indicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(3),
    minWidth: theme.spacing(3),
    width: theme.spacing(3),
    marginRight: theme.spacing(1.5),
    borderRadius: '50%',
    color: theme.palette.neutral.dark,
    backgroundColor: theme.palette.neutral.lightest,
    fontSize: 12,

    '& svg': {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
  tabLabel: {
    textAlign: 'left',
  },
  disabled: {
    '& $title, & $subtitle': {
      color: theme.palette.neutral.light,
    },

    '& $indicator': {
      color: theme.palette.neutral.lighter,
    },
  },
  error: {
    '& $title': {
      color: theme.palette.primary.main,
    },

    '& $indicator': {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.neutral.white,
    },
  },
  success: {
    '& $indicator': {
      backgroundColor: theme.palette.success.dark,
      color: theme.palette.neutral.white,
    },
  },
}))

export default useStyles
